import styled, { keyframes } from 'styled-components';


const fadeFromLeft = keyframes`
from {
  opacity: 0;
  transform: translateX(-50px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;

export const Container = styled.div`
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  min-height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  border-radius: 15px;
  box-shadow: 2px 2px 8px #0002;
  display: flex;
  justify-content: center;
  align-items: center;

  .defaultButton {
     
      background: #888;
      color: white;
      width: 800px;
      padding: 20px;
      text-align: center;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      border: 0;
      border-radius: 15px;

      &:hover {
        opacity: 0.9;
      }

      > svg {
        margin-right: 15px;
      }
    }

    .whiteModalMediumPink {
    background : #AB2292 !important;
    width: 90% !important;
    max-width: 700px;
    
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 
    div{
      background: none !important;

    }

    p,h2{
      color: #fff !important;
    }

    >h2{
      color: #333;
    }
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
     
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }
  }


    .whiteModalMedium {
    background : #fff !important;
    width: 90% !important;
    max-width: 700px;
    
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 

    >h2{
      color: #333;
    }
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
     
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }
  }

  .none{
    background : none !important;
    width: 100% !important;
    height: 100vh;
    z-index: 10000;
  }

  .whiteModalExtra {
    background : #fff;
    width: 100% !important;
    max-width: 600px;

    .content-modal{
      max-height: 80vh !important;
    }
    
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 

    >h2{
      color: #333;
    }
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
          border: 0px !important;
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }
  }



  .whiteModalExtraPage {
    background : none;
    width: 100% !important;
     
    
    border-radius: 15px;
  //  box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 padding: 20px  !important ;

 div.max-600 {
   max-width: 1000px !important;
p{
  font-size: 16px;
}
   p, h2{
     max-width: 100% !important;
   }
 }

 .container-pad {
   padding: 0px;
 }

    >h2{
      display: none ;
    }
 
    .content-modal {
      min-height: 50vh !important;
      max-height: 80vh !important;
      border-radius: 10px;
   
    }

    >div {
      width: 100%;
     
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
          border: 0px !important;
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }
  }

  .whiteModalG {
    background : #fff !important;
    width: 90% !important;
    max-width: 800px;
    
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 

    >h2{
      color: #333;
    }
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
          border: 0px !important;
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }
  }
  
    .whiteModalMini {
    background : #fff !important;
    width: 90% !important;
    max-width: 350px;
    padding: 10px;
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
          border: 0px !important;
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
 
  }
  }

  .whiteModal {
    background : #fff !important;
    width: 90% !important;
    padding: 40px;
    border-radius: 15px;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
 

    >h2{
      color: #333;
    }
 

    >div {
      width: 100%;
      //max-width: 800px;
      
      >form {
        width: 100%;

        >div{
          box-shadow: none !important;
          border: 0px !important;
          padding: 10px;
        }
      }
    }

    @media (max-width: 800px) {
    max-width: 100%;
    padding: 20px 5px;
  }
  }
`;

export const Body = styled.div`
  background: rgba(0, 0, 0, 0.9);
  max-width: 90%;
  justify-content: center;
  padding: 20px 30px;
  animation: ${fadeFromLeft} 1s;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 750px) {
    max-width: 100%;
    padding: 20px 5px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-height: 70vh;
  padding: 10px;
  overflow-y: auto;
 
`;

export const Footer = styled.div`
  width: 100%;
  min-height: 44px;
  
`;


